import script from "./Base.vue?vue&type=script&setup=true&lang=ts"
export * from "./Base.vue?vue&type=script&setup=true&lang=ts"

import "./Base.vue?vue&type=style&index=0&id=29606a4c&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29606a4c"]])

export default __exports__